import React, {useContext, useState, useRef, useEffect} from "react";
import {ConfirmContext} from "../contexts/confirm.js";
import "./Confirm.scss";

export default function Confirm() {
  const [loading, setLoading] = useState(false);
  const {confirm, confirmDispatch} = useContext(ConfirmContext);
  const {actions, visible, message, submitLabel, cancelLabel, submitCallback, cancelCallback, showLoadingOnSubmit} =
    confirm;
  const componentRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (componentRef?.current && !componentRef?.current.contains(event.target)) {
        confirmDispatch({type: "hide"});
        cancelCallback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`confirm-container ${visible && "visible"}`}>
      <div className="screen" />
      <div className="modal" ref={componentRef}>
        <h2>{message}</h2>
        <div className="actions">
          {actions ? (
            actions.map((action, index) => (
              <button
                className={action.className}
                key={`action_${index}`}
                onClick={async () => {
                  if (showLoadingOnSubmit) setLoading(true);
                  try {
                    await submitCallback();
                    confirmDispatch({type: "hide"});
                  } catch (e) {
                    console.error(e);
                  } finally {
                    if (showLoadingOnSubmit) setLoading(false);
                  }
                }}
              >
                {action.label}
              </button>
            ))
          ) : (
            <>
              {submitLabel && (
                <button
                  onClick={async () => {
                    if (showLoadingOnSubmit) setLoading(true);
                    try {
                      await submitCallback();
                      confirmDispatch({type: "hide"});
                    } catch (e) {
                      console.error(e);
                    } finally {
                      if (showLoadingOnSubmit) setLoading(false);
                    }
                  }}
                >
                  {loading ? (
                    <img src="https://hackernoon.com//watch-gif.gif" width={20} alt="saving" className="loading-logo" />
                  ) : (
                    submitLabel
                  )}
                </button>
              )}
              {cancelLabel && (
                <button
                  className="negative"
                  onClick={async () => {
                    confirmDispatch({type: "hide"});
                    await cancelCallback();
                  }}
                >
                  {cancelLabel}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
